export const getDefenseRating = ({ dexterity }) => 12 + dexterity;
